module.exports = __webpack_public_path__ + "static/media/baby_changing.2b6c5c7e.svg";